var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./create.js"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5d874077\",\"hasScoped\":false}!./create.html"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/pages/withNavigation/materials/create/create.vue
// module id = 2796
// module chunks = 1